//#region src/bite_log_adyen_event.ts
var BiteLogAdyenEvent = /* @__PURE__ */ function(BiteLogAdyenEvent) {
	BiteLogAdyenEvent[BiteLogAdyenEvent["TerminalDisconnected"] = 5] = "TerminalDisconnected";
	return BiteLogAdyenEvent;
}(BiteLogAdyenEvent || {});
//#endregion
export { BiteLogAdyenEvent };

//# sourceMappingURL=bite_log_adyen_event.js.map